import { HelpPageContent } from 'components/help_sidebar';
import { FormattedMessage } from 'react-intl';

const strong = (chunks: React.ReactNode) => (
    <strong>
        {chunks}
    </strong>
);

export const helpContent: HelpPageContent = {
    segments: [
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Use the search bar to find partners by name or other attributes. The results table displays all matching <strong>partner organizations</strong>." id="use_the_search_bar_to_find_partners_by_n.73e9147d" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Searching Partners" id="searching_partners.41149159" />
        },
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Click <strong>Create Partner</strong> to add a new partner organization. Fill in the required fields such as <strong>name</strong>, <strong>type</strong>, and <strong>contact information</strong>." id="click_create_partner_to_add_a_new_partne.45a571c1" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Creating a Partner" id="creating_a_partner.14778a82" />
        },
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Click a partner row to open their profile. View and edit organization details, manage settings, and configure partner-specific options." id="click_a_partner_row_to_open_their_profil.92f1109b" />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Partner Details" id="partner_details.a729f457" />
        }
    ],
    title: <FormattedMessage defaultMessage="Partners" id="partners.84d264f4" />
};
